import React from 'react'
import GoogleLogin from 'react-google-login'
import { notification } from 'antd'
import PropTypes from 'prop-types'

import { getEnvironmentVariable } from '../../../../core/helpers'

const onFailure = () =>
  notification.open({
    message: 'Login with google failed.',
    type: 'error',
    duration: 0,
  })

const GoogleLoginButton = ({ onSuccess }) => {
  const clientId = getEnvironmentVariable('REACT_APP_GOOGLE_CLIENT_ID')

  return (
    <GoogleLogin
      clientId={clientId}
      buttonText="Login"
      onSuccess={onSuccess}
      onFailure={onFailure}
    />
  )
}

GoogleLoginButton.propTypes = {
  onSuccess: PropTypes.func.isRequired,
}

export default GoogleLoginButton
